export const startItems = [
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0448-e1647697640288-700x700.jpg", 
        name: "Martin",
        group: ['founder'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/profile-picture-6-700x700.jpg", 
        name: "Charles",
        group: ['founder'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0285-e1647697600312-700x701.jpg", 
        name: "Jochem",
        group: ['founder'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0452-1-scaled-e1647697920645-700x700.jpg", 
        name: "Kees",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0545-e1647697478547-700x700.jpg", 
        name: "Roemer",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/03/gosia.jpg", 
        name: "Gosia",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0202_websize-e1647697460333-700x700.jpg", 
        name: "Jeroen",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0568-scaled-e1647697699625-700x700.jpg", 
        name: "David",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/02/Profile_picture_Ihor.jpeg", 
        name: "Ihor",
        group: ['product'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/02/profile_picture_2-700x701.jpeg", 
        name: "Bastiaan",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0270-e1647697439278-700x701.jpg", 
        name: "Alexis",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0398-e1647697419598-700x700.jpg", 
        name: "Kaspar",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/03/22_02-TheyDo-0600-e1647697389201-700x700.jpg", 
        name: "Guido",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/05/Cristian.jpeg", 
        name: "Cristian",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/05/Dario-Brozzi.jpeg", 
        name: "Dario",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/05/alex-malka.jpeg", 
        name: "Alex",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2022/11/Screen-Shot-2022-11-15-at-18.44.23-700x700.png", 
        name: "Jeroen",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Screen-Shot-2023-01-13-at-16.44.28-700x700.png", 
        name: "Patience",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_picture_Aurora.jpeg", 
        name: "Aurora",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_picture_Vess.jpeg", 
        name: "VEss",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_picture_Matt.png", 
        name: "Matt",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_picture_Pablo-700x703.jpg", 
        name: "Pablo",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_picture_Josef.jpeg", 
        name: "Josef",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/01/Profile_pic_Carmen-700x695.jpg", 
        name: "Carmen",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/Profile_pic_Alexander-700x700.jpg", 
        name: "Alexander",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/Profile_picture_Bruno.jpeg", 
        name: "Bruno",
        group: ['product'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/Profile_picture_Abigail.jpeg", 
        name: "Abigail",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/Profile_picture_Tingting.jpeg", 
        name: "Ting ting",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/julia-1-700x700.png", 
        name: "Julia",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/02/Ernie-Pic.jpg", 
        name: "Ernie",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/03/Profile_pic_Nico.jpeg", 
        name: "Nico",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/03/Profile_pic_Timo.jpeg", 
        name: "Timo",
        group: ['product', 'use'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/03/Profile_pic_Robyn.jpeg", 
        name: "Robyn",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/03/Profile_pic_Anthony.jpeg", 
        name: "Anthony",
        group: [],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/04/Pofifle_pic_Justas.jpeg", 
        name: "Justas",
        group: ['product', 'land'],
    },
    { 
        img: "https://www.theydo.com/wp-content/uploads/2023/04/Profile_pic_Michel.jpeg", 
        name: "Michel",
        group: ['product', 'use'],
    }
]

export const wedgeColors = [
    '#0dbe98',
    '#edc200',
    '#816ade',
    '#50b83c',
    '#f49342',
    '#2175d9',
]

export const addColor = (itemArray) => {
	
	const colored = itemArray.map((item, i) => {
		let color = wedgeColors[i % wedgeColors.length]
		// last wedge color !== first wedge color
		if (i === itemArray.length - 1 && color === wedgeColors[0] && itemArray.length > 1) {
			color = wedgeColors[2]
		}
		return {
			...item,
			color,
		}
	})
	return colored
}